import {css, cx} from "@pandacss/css";
import {FC, ReactNode} from "react";
import {createPandaComponent} from "../helpers/pandaComponent.ts";

type SpacingName = "0" | "4" | "8" | "12" | "16" | "20" | "24" | "28" | "32" | "36" | "40" | "44" | "48" | "52" | "56" | "60" | "64" | "68" | "72" | "76" | "80"

const gaps: Record<SpacingName, string> = {
    "0": css({ gap: "0px" }),
    "4": css({ gap: "4px" }),
    "8": css({ gap: "8px" }),
    "12": css({ gap: "12px" }),
    "16": css({ gap: "16px" }),
    "20": css({ gap: "20px" }),
    "24": css({ gap: "24px" }),
    "28": css({ gap: "28px" }),
    "32": css({ gap: "32px" }),
    "36": css({ gap: "36px" }),
    "40": css({ gap: "40px" }),
    "44": css({ gap: "44px" }),
    "48": css({ gap: "48px" }),
    "52": css({ gap: "52px" }),
    "56": css({ gap: "56px" }),
    "60": css({ gap: "60px" }),
    "64": css({ gap: "64px" }),
    "68": css({ gap: "68px" }),
    "72": css({ gap: "72px" }),
    "76": css({ gap: "76px" }),
    "80": css({ gap: "80px" }),
}

const paddings: Record<SpacingName, string> = {
    "0": css({padding: "0px"}),
    "4": css({padding: "4px"}),
    "8": css({padding: "8px"}),
    "12": css({padding: "12px"}),
    "16": css({padding: "16px"}),
    "20": css({padding: "20px"}),
    "24": css({padding: "24px"}),
    "28": css({padding: "28px"}),
    "32": css({padding: "32px"}),
    "36": css({padding: "36px"}),
    "40": css({padding: "40px"}),
    "44": css({padding: "44px"}),
    "48": css({padding: "48px"}),
    "52": css({padding: "52px"}),
    "56": css({padding: "56px"}),
    "60": css({padding: "60px"}),
    "64": css({padding: "64px"}),
    "68": css({padding: "68px"}),
    "72": css({padding: "72px"}),
    "76": css({padding: "76px"}),
    "80": css({padding: "80px"})
}

const alignItemsCenter = css({
    alignItems: "center"
});

const justifyContentCenter = css({
    justifyContent: "center"
});

const columnBase = css({
    display: "flex",
    flexDirection: "column"
})

const rowBase = css({
    display: "flex",
    flexDirection: "row"
})

const wrap = css({
    flexWrap: "wrap"
})

const growClass = css({
    flex: 1,
});

interface LayoutProps {
    children: ReactNode;
    gap?: SpacingName;
    padding?: SpacingName;
    centerVertically?: boolean;
    centerHorizontally?: boolean;
    grow?: boolean;
}

export const Column: FC<LayoutProps> = ({children, gap = "0", padding = "0", centerVertically = false, centerHorizontally = false, grow = false}) => {
    const columnClass = cx(
        'column',
        columnBase,
        gaps[gap],
        paddings[padding],
        centerVertically && justifyContentCenter,
        centerHorizontally && alignItemsCenter,
        grow && growClass,
    );

    return (<div className={columnClass}>{children}</div>);
}

export const Row: FC<LayoutProps> = ({children, gap = "0", padding = "0", centerVertically = false, centerHorizontally = false, grow = false}) => {
    const rowClass = cx(
        'row',
        rowBase,
        gaps[gap],
        paddings[padding],
        centerVertically && alignItemsCenter,
        centerHorizontally && justifyContentCenter,
        grow && growClass,
    );

    return (<div className={rowClass}>{children}</div>);
};

export const WrapRow: FC<LayoutProps> = ({children, gap = "0", padding = "0", centerVertically = false, centerHorizontally = false, grow = false}) => {
    const wrapRowClass = cx(
        'wrap-row',
        rowBase,
        wrap,
        gaps[gap],
        paddings[padding],
        centerVertically && alignItemsCenter,
        centerHorizontally && justifyContentCenter,
        grow && growClass,
    );

    return (<div className={wrapRowClass}>{children}</div>);
}

const flexSpaceClass = css({
    flex: 1,
});
export const FlexSpace = createPandaComponent('FlexSpace', 'div', flexSpaceClass)